import {checkField} from "../../../design-system/js/form-validator/checkFields";

// NB :  Pour utiliser les utils du Design System mais en éviatn de trainer partout window.x.y... qui n'est pas super clean
// Si on refacto en package clean il suffira de remplacer par un import
const DS = window.DesignSystem

// TODO extraire dans son propre fichier
const metaResolvers = {
    organizationCode: (value) => {
        return {
            type: DS?.utils?.detectOrganizationCodeType?.(value) ?? null
        }
    }
}

/**
 * Crée un store basique pour gérer un formulaire allpine
 *
 */
export function createBaseStore({ storeName, formName, sfFieldNameSuffix = '' }) {
    return {
        storeName,
        formName,
        values: {},
        errors: {},
        meta: {},
        serverErrors: {},
        serverValidation: {},
        touched: {},

        defaultDefinition: { innerRules: true },
        definitions: {},
        changeHandlers : {},

        fieldMap: {},
        errorMessages: {},
        orgService: null,
        submitFailed: false,
        showErrorSummary : false,
        multiFieldValidators: [],

        _hooks: {
            beforeInit: [],
            afterInit: [],
        },

        init() {
            //console.log(`Creating store  ${this.formName}`);
            this.formName = formName;
            if (sfFieldNameSuffix) {
                this.sfFieldNameSuffix = sfFieldNameSuffix;
            } else  this.sfFieldNameSuffix = ''

            // before
            for (const fn of this._hooks.beforeInit) {
                fn.call(this)
            }

            // init principal

            // Récupération des textes pour les messages d'erreur
            const el = document.getElementById('usecase-error-messages')
            this.errorMessages = el
                ? JSON.parse(el.textContent)
                : {}
            //console.log(`Store post hooks  ${this.formName}`);
            // after
            for (const fn of this._hooks.afterInit) {
                fn.call(this)
            }
            console.log(`Store created  ${this.formName}`);
        },

        reset() {
            this.values = {}
            this.errors = {}
            this.serverErrors = {}
            this.touched = {}
            this.meta = {}
            this.serverValidation = {}
            this.submitFailed = null
        },

        debug() {
            console.log('STORE values:', JSON.stringify(this.values))
            console.log('STORE submitFailed:', this.submitFailed ? 'true' : 'false')
            console.log('STORE errors (client-side):', JSON.stringify(this.errors))
            console.log('STORE errors (server-side):', JSON.stringify(this.serverErrors))
            console.log('STORE touched:', JSON.stringify(this.touched))
            console.log('STORE meta:', JSON.stringify(this.meta))
            console.log('STORE serverValidation:', JSON.stringify(this.serverValidation))
        },

        initServerErrors(errors) {
            //console.log('init server errors');
            //console.log(errors);

            this.serverErrors = errors || {}
        },

        initField(name, value) {
        //    console.trace('initField : ' + name + ' - ' + value);
            this.values[name] = value
            this._setField(name, value)
        },

        _setField(name, value) {
            // Validation live du champ
            this.validateField(name);
            this.validateMultiFieldsRules(name);

            if (metaResolvers[name]) {
                this.meta[name] = metaResolvers[name](value)
            } else this.meta[name] = {};

            if (this.changeHandlers[name]) {
                this.changeHandlers[name](value)
            }

        },

        addChangeHandler(name, handler) {
            this.changeHandlers[name] = handler
        },

        setField(name, value) {
            //console.log('setField : ' + name + ' - ' + value + ' old value '+ this.values[name]);
            const oldValue = this.values[name];
            this.values[name] = value

            // Purge des erreurs serveur avant validation
            if (this.serverErrors?.[name]) {
                delete this.serverErrors[name]
            }
            if (oldValue !== value) {
                this._setField(name, value)
            }

            this.touched[name] = true;
            // Reset de l'affichage global des erreurs
            if (this.submitFailed) {
                if (Object.keys(this.errors).length === 0){
                    this.submitFailed = false;
                }
            }
        },

        getFieldState(name) {

            if (!this.values.hasOwnProperty(name)) return null
            //console.log('getFieldState : ' + name + ' -  meta : '  + JSON.stringify(this.meta[name]));
            const info = {
                value : this.values[name],
                valid : !(this.errors.hasOwnProperty(name)),
                error : this.getErrorMessages(name),
                meta : this.meta[name],
                server : null

            }

            // async server state
            if (this.serverValidation?.[name]) {
                const server = this.serverValidation[name]

                info.server = {
                    status: server.status,
                    data: server.data,
                    isStale: server.lastCheckedValue !==  this.values[name]
                }
            }

            return info;
        },


        /**
         * Résout le vrai name HTML Symfony
         */
        resolveFieldName(name) {
            return this.fieldMap[name] || (this.sfFieldNameSuffix + "[" + name + "]")
        },

        /**
         * Marque le champ comme "utilisé".
         */
        touch(name) {
          //  console.log('touched : ' + name);
            this.touched[name] = true
            if (Object.keys(this.serverErrors).includes('global')) {
                // remove prop
                console.log('touch : resetting global error');
                delete this.serverErrors.global
            }
        },

        markAllTouched() {
            for (const name in this.values) {
                this.touched[name] = true
            }
        },

        addError(field, error) {
            const list = (this.errors[field] ??= []);
            //console.log('--- addError : ' + field + ' - ' + error);
            //console.log(JSON.stringify(this.errors));
            if (!list.includes(error)) {
                list.push(error);
            }
        },

        setErrors(field, errors) {
            // Empty our errors array and all incoming errors one by one
            this.errors[field] = errors;
        },

        removeError(field, error) {
            if (!Array.isArray(this.errors[field])) return;

            this.errors[field] = this.errors[field].filter(e => e !== error);

            if (this.errors[field].length === 0) {
               this.clearErrors(field);
            }
        },
        clearErrors(field) {
            //console.log('clearErrors : ' + field);
            if (!this.errors.hasOwnProperty(field)) return;
            delete this.errors[field];
        },

        validateField(name, multiFieldValidation = true) {
            try {
                //console.log('validateField : name = ' + name + ' - store value = ' +  this.values[name]);
                const options = this.definitions[name] || this.defaultDefinition

                const domName = this.resolveFieldName(name)

                const result = checkField(domName, options)
                //console.log('validateField : name = ' + name + ' - store value = ' +  this.values[name] + ' - result =' + result);
                if (result === true) {
                    this.clearErrors(name)
                } else {
                    this.errors[name] = result
                }

                if (multiFieldValidation && this.multiFieldValidators.length > 0){
                    this.validateMultiFieldsRules(name);
                }

                // Au cas où un validateur custom n'a pas bien nettoyé
                if (this.errors.hasOwnProperty(name) && this.errors[name].length === 0) {
                    console.log("Erreur not supprimée sur "+ name +", veuillez vérifier votre validation custom nettoie bien les erreurs");
                    this.clearErrors(name);
                }

            } catch (e) {
                console.warn('Validation error on field:', name, e)
            }
        },


        validateMultiFieldsRules(fieldName) {
            for (const validator of this.multiFieldValidators) {
                if (validator.accept(fieldName)) {
                    validator.validate(this, fieldName);
                }
            }
        },

        validateAll() {

            const errors = {}
            for (const name in this.values) {
                this.validateField(name)
            }
            for (const validator of this.multiFieldValidators) {
                validator.validate(this);
            }

        },

        getField(name) {
        //    console.trace('getField : ' + name + ' - ' + this.values[name]);
            return this.values[name] ?? ''
        },

        hasError(fieldName) {
           /* console.log('hasError : touched = ' + this.touched[fieldName + ''] + ' - errors  =' + this.errors[fieldName] +
                ' - serverValidation = ' +  this.serverValidation[fieldName]?.status + ' - serverErrors = ' + this.serverErrors[fieldName]
            );*/
            return (
                (this.touched[fieldName]  && this.errors[fieldName])
                || this.serverErrors[fieldName] ||
                (this.serverValidation[fieldName]?.status === 'pending'
                    || this.serverValidation[fieldName]?.status === 'error')
            );
        },

        getErrorMessages(name) {
            //console.log('getErrorMessages : ' + name);
            const clientCodes = this.errors[name]
            const serverCodes = this.serverErrors[name]

            const list = [
                ...(Array.isArray(clientCodes) ? clientCodes : clientCodes ? [clientCodes] : []),
                ...(Array.isArray(serverCodes) ? serverCodes : serverCodes ? [serverCodes] : [])
            ]

            if (list.length === 0) return null

            return list.map(code =>
                this.errorMessages[code] || code
            )
        },

        findFirstFieldWithError() {

            const fields = new Set();
            // Parcours de values pour respecter l'ordre d'apparition des composants
            // cet ordre est bon car ils vont s'initialiser dans leur ordre d'apparition dans le dom
            for (const [name, value] of Object.entries(this.values || {})) {

                if (this.hasError(name))
                {
                    fields.add(name)
                }
            }

            const first = fields.values().next().value
            //console.log('findFirstFieldWithError : ' + first);
            if (!first) return null

            return this.resolveFieldName(first)
        },

        isFormValid() {

            // 1. Validation d'erreurs client-side
            if (Object.keys(this.errors).length > 0) {
                return false
            }

            // 2. Validation serveur-side : organizationCode
            if (this.isServerSideValidationPendingOrInError()){
                return false
            }

            return true
        },

        isServerSideValidationPendingOrInError(){

            return Object.values(this.serverValidation).some(v => v?.status === 'pending' || v?.status === 'error')
        },

        hasPendingServerValidation() {
            return Object.values(this.serverValidation).some(v => v?.status === 'pending')
        },

        get displayErrorSummary() {
            //console.trace('displayErrorSummary store' + this.submitFailed);
            return this.submitFailed || Object.keys(this.serverErrors).length > 0;
        },

        get hasGlobalErrors() {
            return Object.keys(this.serverErrors).includes('global') ||
                Object.keys(this.errors).includes('global');
        },

        get hasNonGlobalErrors() {
            return Object.keys(this.serverErrors).length > 1 ||
                Object.keys(this.serverErrors).length === 1 && !Object.keys(this.serverErrors).includes('global') ||
                Object.keys(this.errors).length > 1 ||
                Object.keys(this.errors).length === 1 && !Object.keys(this.errors).includes('global')

                ;
        },

        get globalErrors() {
            if (!this.hasGlobalErrors) return [];
            let res = [];
            let errors = this.serverErrors['global'] ?? [];
            for(const error of errors){
                if (this.errorMessages.hasOwnProperty(error)){
                    res.push(this.errorMessages[error]);
                }
            }
            return res;
        }
    };
}
